import React from 'react';
import { useIntl } from 'react-intl';

import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { UIMenuItemAvailabilityStatus } from 'rdx/menu/types';

const styles = {
  select: {
    '& .MuiSelect-select': {
      pt: 1.75,
      pl: 1.75,
      pb: 1,
      width: 150,
      display: 'flex',
      justifyContent: 'center',
    },
  },
} as const;

interface MenuItemAvailabilitySelectProps {
  name: string;
  value: UIMenuItemAvailabilityStatus;
  showLabel?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange: (e: SelectChangeEvent<any>) => void;
}

const MenuItemAvailabilitySelect: React.FC<MenuItemAvailabilitySelectProps> = ({
  name,
  value,
  onChange,
  ...inputFieldProps
}) => {
  const intl = useIntl();
  return (
    <Select
      {...inputFieldProps}
      value={value}
      variant="outlined"
      name={String(name)}
      id={String(name)}
      onChange={onChange}
      sx={styles.select}
    >
      <MenuItem value={UIMenuItemAvailabilityStatus.available}>
        {intl.formatMessage({ id: 'widgets.MenuEditor.available' })}
      </MenuItem>
      <MenuItem value={UIMenuItemAvailabilityStatus.notToday}>
        {intl.formatMessage({ id: 'widgets.MenuEditor.notToday' })}
      </MenuItem>
      <MenuItem value={UIMenuItemAvailabilityStatus.nevermore}>
        {intl.formatMessage({ id: 'widgets.MenuEditor.nevermore' })}
      </MenuItem>
      <MenuItem value={UIMenuItemAvailabilityStatus.hidden}>
        {intl.formatMessage({ id: 'widgets.MenuEditor.hidden' })}
      </MenuItem>
    </Select>
  );
};

export default MenuItemAvailabilitySelect;
